import React, { PureComponent } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { reduxForm } from "redux-form/immutable";

import {
  ACTIONS,
  SUB_CONTRACTOR_COMPANY_FORM,
} from "features/planner/planner.constants";

import { getActionDataStateFromState } from "app/app.selectors";
import {
  subContractorCompanyOnLoad,
  updateSubContractorCompanyFormOnChange,
} from "features/planner/planner.actions";
import {
  getSubContractorFromState,
  getCompaniesFromState,
} from "features/planner/planner.selectors";
import SubContractorCompanyForm from "features/planner/subcontractor/company/components/SubContractorCompanyForm";
import BasePage from "app/components/BasePage";

class SubContractorCompanyContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad, subContractor } = this.props;

    dispatchOnLoad(subContractor.getIn(["employee", "companyId"]));
  }

  render() {
    const { Icon, dataState, companies } = this.props;

    return (
      <BasePage Icon={Icon} dataState={dataState}>
        <Grid container spacing={4}>
          <SubContractorCompanyForm companies={companies} />
        </Grid>
      </BasePage>
    );
  }
}

export default compose(
  connect(
    (state, { employeeCardId }) => {
      return {
        dataState: getActionDataStateFromState(state, ACTIONS.GET_COMPANIES),
        subContractor: getSubContractorFromState(state, employeeCardId),
        companies: getCompaniesFromState(state),
      };
    },
    {
      dispatchOnLoad: subContractorCompanyOnLoad,
    },
  ),
  reduxForm({
    form: SUB_CONTRACTOR_COMPANY_FORM.ID,
    onChange: updateSubContractorCompanyFormOnChange,
  }),
)(SubContractorCompanyContainer);
